<p-card>
  <div class="text-center mb-5">
    <div class="text-900 text-2xl font-medium mb-3">{{ title }}</div>
    <span class="text-600 font-medium">{{ subtitle }}</span>
  </div>
  <ng-content></ng-content>
</p-card>
